import { render, staticRenderFns } from "./HangingRubberPendant.vue?vue&type=template&id=958560e8&scoped=true&"
import script from "./HangingRubberPendant.vue?vue&type=script&lang=js&"
export * from "./HangingRubberPendant.vue?vue&type=script&lang=js&"
import style0 from "./HangingRubberPendant.vue?vue&type=style&index=0&id=958560e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958560e8",
  null
  
)

component.options.__file = "HangingRubberPendant.vue"
export default component.exports